import { Component, OnInit } from "@angular/core";
import { SeoServiceService } from "src/app/services/seo-service.service";

@Component({
  selector: "app-careers",
  templateUrl: "./careers.component.html",
  styleUrls: ["./careers.component.scss"],
})
export class CareersComponent implements OnInit {
  constructor(private seoService: SeoServiceService) {}

  ngOnInit(): void {
    this.seoService.createLinkForCanonicalURL();
  }

  jobs = [
    "Android App Developer",
    "iOS Developer",
    "Dev-Ops Engineer",
    "Full Stack Developer",
    "Designer (UI/UX)",
    "Website Developer",
    "Content Director",
    "Content Writer",
    "Quality Check Analyst",
    "Social Media Campaign Manager",
    "Operations Executives - Client Servicing",
    "Call Centre (BPO Operations)",
  ];
}
